import { Component, Input, computed, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { CalculationModuleService } from '@core/services/calculation-module.service'
import { CMSessionService } from '@core/services/cm-session.service'
import { LayerResultService } from '@core/services/layer-result.service'
import { environment } from '@env/environment'
import { ExportDataService } from './export-data.service'
import { PdfService } from './pdf.service'

@Component({
  selector: 'app-export-data',
  templateUrl: './export-data.component.html',
  styleUrls: ['./export-data.component.scss'],
  imports: [
    //Material
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class ExportDataComponent {
  @Input() tabSelected: string = ''

  private readonly _exportDataService = inject(ExportDataService)
  calculationModuleService = inject(CalculationModuleService)
  private readonly _layerResultService = inject(LayerResultService)
  private readonly _cmSessionService = inject(CMSessionService)
  private readonly _pdfService = inject(PdfService)

  activeCMSessions$ = this._cmSessionService.activeCMSessions$
  isCMRunning$ = this.calculationModuleService.isCMRunning$
  allLayerResults$ = this._layerResultService.allLayerResults$
  allCharts$ = this._exportDataService.allCharts$
  isExportButtonVisible$ = computed(() => {
    return (
      (this.allLayerResults$().layers.length > 0 &&
        this.allLayerResults$().layers.some((layer) => layer.values.length > 0)) || //layers "No indicators available"
      this.activeCMSessions$().length > 0
    )
  })

  exportIndicators() {
    this._exportDataService.exportIndicators(this.tabSelected)
  }

  exportGraphic() {
    this._exportDataService.exportGraphic(this.tabSelected)
  }

  async exportToPdf() {
    const layerResults = this.allLayerResults$().layers
    const indicators = this._exportDataService.indicatorsToCSV(
      layerResults,
      this.activeCMSessions$(),
    )

    const title = environment.appName + ' results'
    const fileName =
      environment.appName + '_results_' + this._exportDataService.generateDateForFileName() + '.pdf'

    const pdf = await this._pdfService.generateDynamicPdf(title, indicators, this.allCharts$())
    pdf.save(fileName)
  }
}
